import React from "react";
import styles from "./centerRightLayout.module.css";
import { GridLayout } from "~components/Grid/GridLayout";
import { GridCenterContent } from "~components/Grid/GridCenterContent";
import { GridRightContent } from "~components/Grid/GridRightContent";

type Props = {
  contentWell: React.ReactNode;
  rightRail?: React.ReactNode;
};

export default function CenterRightLayout({ contentWell, rightRail }: Props) {
  return (
    <div>
      <GridLayout className={styles.gridContentWrapper}>
        <GridCenterContent className={styles.rightCenterContent}>
          {contentWell}
        </GridCenterContent>
        <GridRightContent>
          <div className={styles.rightRailWrapper}>
            <div className={styles.stickyEnabled}>{rightRail}</div>
          </div>
        </GridRightContent>
      </GridLayout>
    </div>
  );
}
